import { ACCOUNTING_CYCLE_EVENTS } from 'domain/finance/costAccounting/accountingCycle/useAccountingCycle';
import PerformPayrollDistributionButton from 'domain/finance/payroll/payrollDistribution/shared/button/PerformPayrollDistributionButton';
import { LinkButton } from 'framework/ui/ui-builder';
import ComputeBonusesButton from 'domain/finance/expenses/shared/button/ComputeBonusesButton';
import PerformAssetCostProratingButton from 'domain/finance/assets/shared/button/PerformAssetCostProratingButton';
import AccrueRevenueButton from 'domain/finance/costAccounting/accountingCycle/shared/button/AccrueRevenueButton';
import { useShowContext } from 'framework/show';
import ComputeEmployeeAccrualsButton from 'domain/finance/expenses/shared/button/ComputeEmployeeAccrualsButton';

const AccountingCycleActionButton = ({ id }: { id: string }) => {
  const { data } = useShowContext();
  const event = data.getValueBySource('event');
  const disabled = !!data.getValueBySource('createdAt');

  switch (event) {
    case ACCOUNTING_CYCLE_EVENTS.PAYROLL_DISTRIBUTION:
      return (
        <PerformPayrollDistributionButton
          initialValue={id}
          disabledInput
          variant="outlined"
          startIcon={null}
          disabled={disabled}
        />
      );
    case ACCOUNTING_CYCLE_EVENTS.ACCRUE_REVENUE:
      return (
        <AccrueRevenueButton initialValue={id} disabledInput variant="outlined" startIcon={null} disabled={disabled} />
      );
    case ACCOUNTING_CYCLE_EVENTS.COST_PRORATING:
      return <PerformAssetCostProratingButton disabledInput initialValue={id} disabled={disabled} />;
    case ACCOUNTING_CYCLE_EVENTS.RECONCILIATION:
      return (
        <LinkButton disabled={disabled} variant="outlined" color="primary" url="/reconciliation">
          Reconciliation page
        </LinkButton>
      );
    case ACCOUNTING_CYCLE_EVENTS.COMPUTE_PERFORMANCE_BASED_BONUS:
      return <ComputeBonusesButton disabledInput initialValue={id} disabled={disabled} />;
    case ACCOUNTING_CYCLE_EVENTS.COMPUTE_EMPLOYEE_EXPENSE_ACCRUAL:
      return <ComputeEmployeeAccrualsButton disabledInput initialValue={id} />;
    default:
      return <></>;
  }
};

export default AccountingCycleActionButton;
